import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_FOOD_SERVICE_ENDPOINT || 'http://localhost:4000';

export interface ImportResult {
  jobId?: number;
  status?: string;
  fileName?: string;
  totalRows?: number;
  successfulRows?: number;
  failedRows?: number;
  skippedRows?: number;
  errors?: ImportError[];
  message?: string;
}

export interface ImportError {
  rowNumber?: number;
  errorType?: string;
  errorMessage?: string;
  rowData?: Record<string, unknown>;
}

interface ApiResponse {
  success?: boolean;
  message?: string;
  data?: ImportResult;
}

/**
 * Upload food Excel file to MLAS Food API.
 */
export async function importFoodExcel(file: File): Promise<ImportResult> {
  const formData = new FormData();

  formData.append('file', file);

  try {
    const response = await axios.post<ApiResponse>(
      `${API_BASE_URL}/v1/foods/import`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return {
      ...(response.data?.data || {}),
      message: response.data?.message
    };
  } catch (error: any) {
    console.error('Food Excel import failed:', error);

    const backendMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      'Failed to import food Excel file.';

    throw new Error(backendMessage);
  }
}
